export const DOCUMENT_SELECTION_MODES = {
  myUploads: 'myUploads',
  company: 'company',
};

export const generateDocumentSelectionModeName = (mode) => {
  switch (mode) {
    case DOCUMENT_SELECTION_MODES.myUploads:
      return 'Uploaded documents';
    case DOCUMENT_SELECTION_MODES.company:
      return 'Search by Company / Tag';

    // case DOCUMENT_SELECTION_MODES.docType:
    //   return 'Search by document type';
    // case DOCUMENT_SELECTION_MODES.ppm:
    //   return 'Search by PPM documents/ side letters';
    // case DOCUMENT_SELECTION_MODES.credit:
    //   return 'Search by credit documents';
    // case DOCUMENT_SELECTION_MODES.speaker:
    //   return 'Search by speaker';
    // case DOCUMENT_SELECTION_MODES.companyTag:
    //   return 'Search by Company / Tag';
    // case DOCUMENT_SELECTION_MODES.allCompany:
    //   return 'Search by Company / Tag';
    // case DOCUMENT_SELECTION_MODES.docName:
    //   return 'Search by document name';
    // case DOCUMENT_SELECTION_MODES.news:
    //   return 'Search by news';
    // case DOCUMENT_SELECTION_MODES.myDocs:
    //   return 'Uploaded documents';
    // case DOCUMENT_SELECTION_MODES.website:
    //   return 'Website uploads';
    // case DOCUMENT_SELECTION_MODES.fedDoc:
    //   return 'Search macro documents';
    // case DOCUMENT_SELECTION_MODES.customMode:
    //   return 'Mode Specific';
    // case DOCUMENT_SELECTION_MODES.sector:
    //   return 'Search by description';
    default:
      return 'Missing mode';
  }
};
